import { useId, type InputHTMLAttributes } from "react";

export interface ColorFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
}

/**
 * A labelled colour picker — a native `<input type="color">` swatch with the hex value shown
 * alongside. The form vocabulary for a stored hex colour (e.g. an animal-tag colour). Token-styled;
 * controlled via `value`/`onChange` like {@link Field}. Label/input are linked via an explicit id so
 * the association is robust regardless of nesting; the hex echo is `aria-hidden` so the input's
 * accessible name is exactly the label.
 */
export function ColorField({ label, value, id, ...rest }: ColorFieldProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <div className="fui-field">
      <label className="fui-field__label" htmlFor={inputId}>
        {label}
      </label>
      <span className="fui-color">
        <input id={inputId} type="color" className="fui-color__swatch" value={value} {...rest} />
        <span className="fui-color__hex" aria-hidden="true">
          {typeof value === "string" ? value : ""}
        </span>
      </span>
    </div>
  );
}
